import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=229355d2&scoped=true&"
import script from "./chapter.vue?vue&type=script&lang=js&"
export * from "./chapter.vue?vue&type=script&lang=js&"
import style0 from "./chapter.vue?vue&type=style&index=0&id=229355d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229355d2",
  null
  
)

export default component.exports